export default {
    navbar: {//头部信息
        welcomes: '欢迎使用',
        companyName: '奥林德尔商城',
		switch:'语言版本',
		login:'登录',
		quit:'退出登录',
		registration:'免费注册',
		homePage:'首页',
		personal:'个人中心',
		contactService:'联系客服',
		mobile:'手机版',
		myCart:'我的购物车',
		search:'搜索',
		contentSearch:'请输入内容搜索',
		homepage:'返回首页',
		siteActions:'请登录APP或扫码进入手机网站进行操作',
    },
	foots:{//底部信息
		customerService:'手机号',
		contactAddress:'联系地址',
		QRcode:'扫描二维码',
		obtain:'获取全网优质商品',
		operatedMallApp:'下载自营商城APP',
		copyright:'版权所有',
	},
	commodity:{//商品页面数据信息
		sort:'排序',
		none:'暂无数据',
		groupBuying:'拼团购',
		collect:'收藏商品',
		deliveryPrice:'到手价',
		share:'分享赚',
		salesVolume:'销 量',
		monthlySales:'月销',
		quantity:'数 量',
		buyNow:'立即购买',
		shoppingCart:'加入购物车',
		show:'商品展示',
		comment:'全部评论',
		user:'用户',
		characters:'描述文字',
	},
	personal:{//个人中心
		homePage:'首页',
		account:'账户设置',
		orderCenter:'订单中心',
		myOrder:'我的订单',
		afterSales:'退换/售后',
		address:'收货地址',
		focusCenter:'关注中心',
		myCollection:'我的收藏',
		myFootprint:'我的足迹',
		assetCenter:'资产中心',
		myWallet:'我的钱包',
		myPoints:'我的积分',
		discountCoupon:'优惠劵',
		allOrders:'全部订单',
		obligation:'待付款',
		toBeShipped:'待发货',
		goodsToBeReceived:'待收货',
		toBeUsed:'待使用',
		toBeEvaluated:'待评价',
		canceled:'已取消',
		refunding:'退款中',
		refunded:'已退款',
		refuseRefund:'拒绝退款',
		inAGroup:'拼团中',
		evaluated:'已评价',
		babyInformation:'宝贝信息',
		unitPrice:'单价',
		yuan:'元',
		dollar:'美元',
		number:'数量',
		disbursements:'实付款',
		transactionStatus:'交易状态',
		transactionOperations:'交易操作',
		orderNumber:'订单编号',
		productSpecifications:'商品规格',
		orderDetails:'订单详情',
		cancellationOfOrder:'取消订单',
		ReasonForCancellation:'取消原因',
		PleaseEnterTheReasonForCancellation:'请输入取消原因',
		refund:'退款',
		ReasonForRefund:'退款原因',
		PleaseEnterTheRefundReason:'请输入退款原因',
		
		toPay:'确认订单',
		reminderShipment:'提醒发货',
		confirmReceipt:'确认收货',
		toEvaluate:'去评价',
		deleteOrder:'删除订单',
		payAmount:'实付金额',
		refundAmount:'退款金额',
		orderTime:'下单时间',
		refundStatus:'退款状态',
		savedShippingAddress:'已保存的收货地址',
		phone:'电话',
		createANewShippingAddress:'新增收货地址',
		consignee:'收货人',
		phoneNumber:'手机号',
		province:'省市区',
		setAsDefaultAddress:'设为默认地址',
		save:'保存',
		myBalance:'我的余额',
		withdrawableAmount:'可提现金额',
		accumulatedWithdrawalAmount:'累计提现金额',
		walletDetails:'钱包明细',
		withdrawalRecords:'提现记录',
		typesOf:'类型',
		content:'内容',
		time:'时间',
		amountOfMoney:'金额',
		nameOfAlipay:'支付宝姓名',
		alipayAccount:'支付宝账号',
		state:'状态',
		withdrawing:'提现中',
		withdrawalSuccessful:'提现成功',
		withdrawalFailed:'提现失败',
		pointsDetails:'积分明细',
		productVoucher:'商品券',
		universalCoupon:'通用券',
		name:'名称',
		fullReduction:'满减',
		periodOfValidity:'有效期',
		full:'满',
		available:'可用',
		validTo:'有效期至',
		pleaseSelectACity:'请选择城市',
		cancellation:'取 消',
		Confirm:'确 定',
		PaymentBox:'确认付款',
		
	},
	orderDetails:{//订单详情
		takeAProduct:'拍下商品',
		paymentSuccessful:'付款成功',
		sellerShipping:'卖家发货',
		commodityInformation:'商品信息',
		putAway:'收',
		discountAmount:'优惠金额',
		totalAmountOfGoods:'商品总金额',
		totalFreightCost:'运费共计',
		logisticsInformation:'物流信息',
		noLogisticsInformationAvailable:'暂无物流信息',
		notes:'备注',
		allProducts:'全部商品',
		delete:'删除',
		selectAll:'全选',
		amountTo:'合计',
		ommediateClosure:'立即结算',
		operate:'操作',
		trackingNumber:'快递单号',
		VehicleImage:'车辆图片',
		ReasonForRejection:'驳回原因',
		ReasonForRefundRequest:'退款申请原因',
		
	},
	personalInformation:{//个人信息
		memberUsers:'用户昵称',
		pleaseEnterANickname:'请输入昵称',
		gender:'性别',
		schoolgirl:'女生',
		schoolboy:'男生',
		modifyPhoneNumber:'修改手机号',
		withdrawalAccount:'提现账号',
		setUp:'设置提现账号便于提现服务',
		setUpWithdrawalAccount:'设置提现账号',
		CUSTOMERSERVICE:'联系客服',
		CreationTime:'创建时间',
		sendFiles:'发送文件',
		PleaseEnterContent:'请输入内容',
		sending:'发送',
		
	},
	paymentPage:{//支付页面
		consigneeInformation:'收货人信息',
		newlyFilledDeliveryAddress:'新增收货地址',
		addressInformation:'暂无地址信息，请添加地址信息',
		freight:'运费(元)',
		leaveAMessage:'给卖家留言',
		specialNeeds:'可以告诉卖家您的特殊需求，需要和卖家协商一致',
		paymentAccount:'支付账号',
		PaymentScreenshot:'支付截图',
		enterYourPaymentAccount:'请输入您的支付账号',
		sentTo:'寄送至',
		submitOrder:'提交订单',
		CommentContent:'评论内容',
		score:'评分',
		Pictures:'上传图片',
		PleaseFillInTheCommentContent:'请填写评论内容',
		comment:'评论',
		
	},
	login:{//登录页面
		WeChatQRCodeLogin:'微信二维码登录',
		welcomeToRegister:'欢迎注册',
		existingAccount:'已有账号',
		logOn:'登录',
		mobileAndEmail:'手机号/邮箱',
		password:'密码',
		forgotPassword:'忘记密码',
		register:'注册',
		enterYourPhoneNumber:'请输入手机号',
		enterTheVerificationCode:'请输入验证码',
		obtainVerificationCode:'获取验证码',
		reacquireInSeconds:'秒后重新获取',
		toScanAndLogIn:'请使用微信扫一扫登录',
		passwordLogin:'密码登录',
		registerAnAccount:'注册账号',
		pleaseSetLoginPassword:'请设置登录密码',
		readAndAccept:'阅读并接受',
		UserAgreement:'用户协议',
		asWellAs:'以及',
		privacyProtectionStatement:'隐私保护声明',
		submitTo:'提交',
		pleaseSetTheUsername:'请设置用户名',
		
	},
	
}


// WEBPACK FOOTER //
// ./src/lang/zh.js